<template>
    <div class="l-nav-bar-menu-mobile">
        <b-sidebar id="menu-mobile" no-header backdrop backdrop-variant="transparent" shadow>
            <template #default="{ hide }">
                <div
                    :class="[
                        'ms-slidebar',
                        'sb-slidebar',
                        'sb-left',
                        'sb-momentum-scrolling',
                        'sb-style-overlay',
                        'sb-active',
                    ]"
                >
                    <header class="ms-slidebar-header">
                        <div class="ms-slidebar-title">
                            <div class="ms-slidebar-t">
                                <h3>leapsome</h3>
                            </div>
                        </div>
                    </header>
                    <ul
                        id="slidebar-menu"
                        class="ms-slidebar-menu"
                        tabindex="0"
                        @click="hide()"
                        @keyup.enter="hide()"
                    >
                        <li v-show="rights.P_VIEW">
                            <a href="#/profile" class="link">
                                {{ $t("menu.profile") }}
                            </a>
                        </li>
                        <l-nav-menu-element
                            v-for="element in menu"
                            :key="element.href"
                            :show="element.show"
                            :href="element.href"
                            :text="element.text"
                            :link-class="'link'"
                        />
                        <li v-show="rights.A_FEAT">
                            <a href="#/skills" class="link">
                                {{ $t("menu.skills") }}
                            </a>
                        </li>
                        <li v-show="rights.A_USER" class="hidden-xs hidden-sm">
                            <a href="#/team/members" class="link">
                                {{ $t("menu.users") }}
                            </a>
                        </li>
                        <li v-show="isLoggedIn">
                            <a class="link" @click="logout()" @keyup.enter="logout()">
                                {{ $t("menu.logout") }}
                            </a>
                        </li>
                        <li v-show="!isLoggedIn">
                            <a href="#/auth/login" class="link">
                                {{ $t("menu.login") }}
                            </a>
                        </li>
                    </ul>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LNavMenuElement from "@/components/LNavMenuElement";

export default {
    components: {
        LNavMenuElement,
    },
    props: {
        menu: {
            type: Array,
            required: true,
        },
        logout: {
            type: Function,
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            isLoggedIn: "auth/isLoggedIn",
            rights: "users/current/rights",
        }),
    },
};
</script>

<style scoped>
/* 
 * To align the Vue side bar with that in Angular, we need to override the width of the Bootstrap sidebar
 * to equal that of `.ms-slidebar`
 */
.l-nav-bar-menu-mobile >>> .b-sidebar {
    width: 300px;
}
</style>
